import classNames from "classnames";

import { FeedbackReportStatus } from "generated/copilot-api-developer";
import { useTranslation } from "i18n";
import { mapEnumValueOrThrow } from "utils/enum";

export const StatusBadge = ({ status }: { status: FeedbackReportStatus }) => {
  const t = useTranslation();
  const open = {
    label: t("developers.feedback_reports.status_open"),
    className: "bg-indigo-100 text-indigo-300",
  };
  const closed = {
    label: t("developers.feedback_reports.status_closed"),
    className: "bg-green-100 text-green-300",
  };
  const { label, className } = mapEnumValueOrThrow(status, {
    OPEN: open,
    PENDING: open,
    WAITING: {
      label: t("developers.feedback_reports.status_in_progress"),
      className: "bg-yellow text-primary-dark",
    },
    RESOLVED: closed,
    SKIPPED: closed,
    FAILED: closed,
  });

  return (
    <div
      className={classNames(
        "rounded px-4 inline-block whitespace-nowrap",
        className,
      )}
    >
      {label}
    </div>
  );
};
